var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots-loader d-flex justify-content-center"},_vm._l((_vm.nbDots),function(i){return _c('div',{key:i,staticClass:"dot-wrapper mx-2"},[_c('div',{staticClass:"dot",style:(("animation-delay: " + (i * .4) + "s"))})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }